 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		42: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		42: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"b4caed78e75505399a99815f17cc3d4addb94723","1":"styles","2":"d8c4c8282aa6fa322c081416385067d53e1226e3","3":"e57bbd7fab728683db1b2d2485922d041892dba3","4":"f36f0ab9","5":"f243dec1503cc2c94e83b2e5fe4a0bad4196d6e8","6":"1405e46376228771075b0867d12e635e324ee18a","7":"3b1780fbe7302b55e2023685244e0fa484620fc5","8":"262274aa","9":"3e884c84951a93e6010309a82bc03b19ea392c14","10":"5bd53f8adcd16021d07d1dab744ac4998686f2cf","11":"a88a3c401ecd441479901ff6f5a4425ca69a0815","12":"ab344ebf7d6a88c2566bdb7529c160ed86f8086f","13":"0b7b90cd","14":"17433bbd","15":"34c81b0e","16":"5c37f29a","17":"64ed05e6","18":"730f7578","19":"73960a32","20":"8dacc9ca","21":"a7314a7d","22":"b35d851f","23":"component---src-pages-about-js","24":"component---src-pages-banderole-js","25":"component---src-pages-cart-js","26":"component---src-pages-contacts-js","27":"component---src-pages-ecobags-color-js","28":"component---src-pages-ecobags-js","29":"component---src-pages-envelopes-individual-js","30":"component---src-pages-envelopes-js","31":"component---src-pages-envelopes-straight-js","32":"component---src-pages-index-js","33":"component---src-pages-individualform-js","34":"component---src-pages-other-js","35":"component---src-pages-printed-js","36":"component---src-pages-products-js","37":"component---src-pages-request-js","38":"component---src-pages-rtg-js","39":"component---src-pages-stericlin-js","40":"component---src-pages-thanxrequest-js","41":"d676735c","44":"component---src-pages-404-js","45":"component---src-pages-about-en-js","46":"component---src-pages-banderole-en-js","47":"component---src-pages-bubblebags-en-js","48":"component---src-pages-bubblebags-js","49":"component---src-pages-cart-en-js","50":"component---src-pages-contacts-en-js","51":"component---src-pages-ecobags-brown-en-js","52":"component---src-pages-ecobags-brown-js","53":"component---src-pages-ecobags-color-en-js","54":"component---src-pages-ecobags-en-js","55":"component---src-pages-ecobags-white-en-js","56":"component---src-pages-ecobags-white-js","57":"component---src-pages-envelopes-en-js","58":"component---src-pages-envelopes-extension-en-js","59":"component---src-pages-envelopes-extension-js","60":"component---src-pages-envelopes-individual-en-js","61":"component---src-pages-envelopes-straight-en-js","62":"component---src-pages-envelopes-thermopack-en-js","63":"component---src-pages-envelopes-thermopack-js","64":"component---src-pages-envelopes-triangular-en-js","65":"component---src-pages-envelopes-triangular-js","66":"component---src-pages-index-en-js","67":"component---src-pages-individualform-en-js","68":"component---src-pages-other-en-js","69":"component---src-pages-printed-en-js","70":"component---src-pages-printform-en-js","71":"component---src-pages-printform-js","72":"component---src-pages-products-en-js","73":"component---src-pages-request-en-js","74":"component---src-pages-rtg-en-js","75":"component---src-pages-sale-js","76":"component---src-pages-stericlin-en-js","77":"component---src-pages-thanxrequest-en-js","78":"component---src-pages-weightcalc-js"}[chunkId]||chunkId) + "-" + {"0":"0221eb39e662626620f1","1":"29147cbc04bbc833f6a0","2":"86ac23e6fba6d6a23be6","3":"1b43a80d01bc305a9aa8","4":"4a909b287d265782fad8","5":"3d03377dc487a2250861","6":"d39e4309464303c1e405","7":"89377d9d41886472da4d","8":"6feefe5c18556ba8599d","9":"a3b636fe4dda6a64c54b","10":"c073fcc38cf941f7cca8","11":"6679bb933fee5647f7d7","12":"a1117094e440a3a75262","13":"e907c6dfa276f1c4b159","14":"ccb5cec19a96ec3725a7","15":"c3d85734bc7bfb5f995f","16":"aef3b45d69f8be2d9738","17":"12dac76962d5d36fed8c","18":"c7d3863d31910c443823","19":"b2463de93ade4d574bcc","20":"d7ef845c7fc4fa60ccb8","21":"72e4a7cd66e4524791d8","22":"36ba2af6078d1e930710","23":"8b1f87ad9018974db982","24":"685979ae2bbd2e56966f","25":"36e1c9104c755751dd53","26":"79819177e90e589a09ef","27":"747268fd9a55699e3f80","28":"70b788ba1748242bc18d","29":"44bfb09bbd2484dd026d","30":"4939b97738c56defd629","31":"5abcf28d5cb30cf71976","32":"bdf2791d247e7894bba8","33":"dbc305f7052d536febe4","34":"13875a06894c0fa57d7b","35":"4399ba1b9fca345fdf07","36":"84fe98e60bd99f86c0f6","37":"b847e77d679e839be37d","38":"53a8a01441bd5eb04829","39":"3e6e150a73e016e0ff14","40":"99d576ba4383a965b298","41":"194bb9bf607e01d397d6","44":"edc0bd05a44bd47adb36","45":"757891333f9be296bd0d","46":"d59cfb5a1bfea96fa1e7","47":"f63b57ec28e1915d1e90","48":"3f574fd5ca9c7b6ac9ef","49":"5cf8f65394bff6d8702c","50":"c4e25053ea00e8a5de27","51":"d9fd19a0dd0cd2e0fb4f","52":"e2a46a62ecefe88390b1","53":"b57d2b309412dbb74078","54":"cd14cbb570ccd1214f7a","55":"439bf5de5272b5d7e79d","56":"388074116d854a06b4f2","57":"4a70b17ff6da86acb6ad","58":"f4b1feca43a6daf188d9","59":"791e5c667d5fc9ca906b","60":"814498c2d64b304fdb12","61":"d5b72eec5aa6b9f778d1","62":"c9753aece5fdfb95d7c1","63":"fb61154ff774d0444b6d","64":"4036d285788b5f9254ea","65":"02ddbe45c8112dc12a82","66":"17c0bc5ca3d311d0ab7a","67":"3c3b9324acefc4a483f1","68":"b6356899cfcca8b9fa96","69":"f58030e559bb60aa0c45","70":"b9c79af3014b2fef1d00","71":"0b35b701bfe934e4b833","72":"f0ff429a35bbc3e7e344","73":"ecf688e68515a9433233","74":"d0f73d47a0244cfd6019","75":"3941f6e7f9226c9aab04","76":"87b5105e3f48f056afa1","77":"a64b7b6e7bee299c5e18","78":"e306adac713a6dd1f867"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"b4caed78e75505399a99815f17cc3d4addb94723","1":"styles","2":"d8c4c8282aa6fa322c081416385067d53e1226e3","3":"e57bbd7fab728683db1b2d2485922d041892dba3","4":"f36f0ab9","5":"f243dec1503cc2c94e83b2e5fe4a0bad4196d6e8","6":"1405e46376228771075b0867d12e635e324ee18a","7":"3b1780fbe7302b55e2023685244e0fa484620fc5","8":"262274aa","9":"3e884c84951a93e6010309a82bc03b19ea392c14","10":"5bd53f8adcd16021d07d1dab744ac4998686f2cf","11":"a88a3c401ecd441479901ff6f5a4425ca69a0815","12":"ab344ebf7d6a88c2566bdb7529c160ed86f8086f","13":"0b7b90cd","14":"17433bbd","15":"34c81b0e","16":"5c37f29a","17":"64ed05e6","18":"730f7578","19":"73960a32","20":"8dacc9ca","21":"a7314a7d","22":"b35d851f","23":"component---src-pages-about-js","24":"component---src-pages-banderole-js","25":"component---src-pages-cart-js","26":"component---src-pages-contacts-js","27":"component---src-pages-ecobags-color-js","28":"component---src-pages-ecobags-js","29":"component---src-pages-envelopes-individual-js","30":"component---src-pages-envelopes-js","31":"component---src-pages-envelopes-straight-js","32":"component---src-pages-index-js","33":"component---src-pages-individualform-js","34":"component---src-pages-other-js","35":"component---src-pages-printed-js","36":"component---src-pages-products-js","37":"component---src-pages-request-js","38":"component---src-pages-rtg-js","39":"component---src-pages-stericlin-js","40":"component---src-pages-thanxrequest-js","41":"d676735c","44":"component---src-pages-404-js","45":"component---src-pages-about-en-js","46":"component---src-pages-banderole-en-js","47":"component---src-pages-bubblebags-en-js","48":"component---src-pages-bubblebags-js","49":"component---src-pages-cart-en-js","50":"component---src-pages-contacts-en-js","51":"component---src-pages-ecobags-brown-en-js","52":"component---src-pages-ecobags-brown-js","53":"component---src-pages-ecobags-color-en-js","54":"component---src-pages-ecobags-en-js","55":"component---src-pages-ecobags-white-en-js","56":"component---src-pages-ecobags-white-js","57":"component---src-pages-envelopes-en-js","58":"component---src-pages-envelopes-extension-en-js","59":"component---src-pages-envelopes-extension-js","60":"component---src-pages-envelopes-individual-en-js","61":"component---src-pages-envelopes-straight-en-js","62":"component---src-pages-envelopes-thermopack-en-js","63":"component---src-pages-envelopes-thermopack-js","64":"component---src-pages-envelopes-triangular-en-js","65":"component---src-pages-envelopes-triangular-js","66":"component---src-pages-index-en-js","67":"component---src-pages-individualform-en-js","68":"component---src-pages-other-en-js","69":"component---src-pages-printed-en-js","70":"component---src-pages-printform-en-js","71":"component---src-pages-printform-js","72":"component---src-pages-products-en-js","73":"component---src-pages-request-en-js","74":"component---src-pages-rtg-en-js","75":"component---src-pages-sale-js","76":"component---src-pages-stericlin-en-js","77":"component---src-pages-thanxrequest-en-js","78":"component---src-pages-weightcalc-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"94d7e5ba78cc0b04bd14","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
